import { render } from "./AdminQR.vue?vue&type=template&id=6b8de4f3"
import script from "./AdminQR.vue?vue&type=script&lang=js"
export * from "./AdminQR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__